import { render, staticRenderFns } from "./collect-user.vue?vue&type=template&id=376fabe8"
import script from "./collect-user.vue?vue&type=script&lang=js"
export * from "./collect-user.vue?vue&type=script&lang=js"
import style0 from "./collect-user.vue?vue&type=style&index=0&id=376fabe8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../Shield.UI.CommsManagerWebsite/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports